import React from "react";
import {
  EmptyStateContainer,
  LoaderContainer,
  MobileContainer,
} from "./CardList.styled";
import CardItem from "../CardItem";
import CardSlider from "../../../../../components/atoms/CardSlider";
import useWindowSize from "../../../../../hooks/useWindowSize";
import { DataEventSeriesItemsProps } from "../../Timeline2025";
// @ts-ignore
import Skeleton from "react-loading-skeleton";
import { func } from "../../../../../utils";

export interface CardListProps {
  isLoading?: boolean;
  data: DataEventSeriesItemsProps[];
}

const CardList: React.FC<CardListProps> = ({
  data = [],
  isLoading = false,
}) => {
  const { size } = useWindowSize();

  //   @ts-ignore
  const isMobileView = (size?.width || 0) <= 768;

  if (data?.length <= 0 && !isLoading) {
    return (
      <EmptyStateContainer>
        <img
          src={func.getStaticImg(
            `${
              isMobileView
                ? "/bg/empty-state-mobile-new.png"
                : "/bg/empty-state-desktop-new.png"
            }`
          )}
        />
      </EmptyStateContainer>
    );
  }

  if (isLoading) {
    return (
      <>
        {isMobileView ? (
          <MobileContainer>
            <Skeleton borderRadius={16} width={157} height={267} />
            <Skeleton borderRadius={16} width={157} height={267} />
            <Skeleton borderRadius={16} width={157} height={267} />
          </MobileContainer>
        ) : (
          <LoaderContainer>
            <Skeleton borderRadius={16} width={325} height={230} />
            <Skeleton borderRadius={16} width={325} height={230} />
            <Skeleton borderRadius={16} width={325} height={230} />
          </LoaderContainer>
        )}
      </>
    );
  }

  return (
    <React.Fragment>
      {isMobileView ? (
        <MobileContainer>
          {data?.map((val, idx) => (
            <CardItem key={idx} data={val} />
          ))}
        </MobileContainer>
      ) : (
        <CardSlider totalData={data?.length}>
          {data?.map((val, idx) => (
            <CardItem key={idx} data={val} />
          ))}
        </CardSlider>
      )}
    </React.Fragment>
  );
};

export default CardList;
